module.exports = __webpack_public_path__ + "fd25cf263f97e81a3b403a06dae0013e.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/cream_pixels.png
 ** module id = 21
 ** module chunks = 0
 **/